import { fetchWrapper } from '@/_helpers';

const getExternalEventsQuery = ({}) => {
    return '';
};

async function getExternalEvents(options = {}) {
    const queryParams = getExternalEventsQuery(options);
    return fetchWrapper.get(`/calendar-integrations/external-events?${queryParams}`);
}

async function checkConnectionStatus() {
    return fetchWrapper.get('/calendars/accounts');
}

async function getExternalCalendarAccounts() {
    return fetchWrapper.get('/calendar-integrations/accounts');
}

async function authorizeCalendar({ calendarProvider }) {
    if (!calendarProvider) {
        throw new Error('Calendar type is required');
    }
    return fetchWrapper.get(`/calendar-integrations/authorize?calendarProvider=${calendarProvider}`);
}

async function disconnectCalendar({ accountId }) {
    return fetchWrapper.delete(`/calendar-integrations/accounts/${accountId}`);
}

async function syncCalendar({ accountId }) {
    return fetchWrapper.post(`/calendar-integrations/accounts/${accountId}/sync`);
}

async function OAuthCallback({ code }) {
    return fetchWrapper.get(`/calendar-integrations/oauth/callback?code=${code}`);
}

async function getConflicts() {
    return fetchWrapper.get('/calendar-integrations/conflicts');
}

async function resolveConflict({ conflictId }) {
    return fetchWrapper.put(`/calendar-integrations/conflicts/${conflictId}/resolve`);
}

async function updateSyncDirection({ accountId, syncDirection }) {
    return fetchWrapper.put(`/calendar-integrations/accounts/${accountId}/sync-direction`, { syncDirection });
}

export const calendarIntegrationService = {
    getExternalEvents,
    checkConnectionStatus,
    getExternalCalendarAccounts,
    authorizeCalendar,
    disconnectCalendar,
    syncCalendar,
    OAuthCallback,
    getConflicts,
    resolveConflict,
    updateSyncDirection,
};
